/**
 * 多功能输入处理组件
 * zxw
 * 创建时间 2026-04-14
 */

import CNF from '../incs/Config';

/**
 * 转存储-转换变量标签内容
 * @param {*} str 
 * @returns 
 */
export const convertVariableTags = (str) => {
    // 创建 DOM 解析器，将 HTML 字符串解析为文档对象
    const parser = new DOMParser();
    const doc = parser.parseFromString(str, 'text/html');
    const fragments = [];

    // 块级元素列表（根据需要扩展）
    const blockElements = new Set(['div']);

    // 非变量字符串
    var nonVariableStr = '';

    // 判断 div 标签的内容是否仅为 br 标签
    function isOnlyBr(e) {
        const nodes = e.childNodes;
        if (nodes.length !== 1) return false;
        const onlyNode = nodes[0];
        return onlyNode.nodeType === Node.ELEMENT_NODE && onlyNode.tagName === 'BR';
    }

    // 递归遍历 DOM 节点，提取文本或 variable-tag 的 data 属性
    function walk(node) {
        if (node.nodeType === Node.TEXT_NODE) {
            const text = node.nodeValue;
            if (text) nonVariableStr += text;
        }
        else if (node.nodeType === Node.ELEMENT_NODE) {
            // 检查是否为目标 variable-tag 元素
            if (node.classList && node.classList.contains('variable-tag')) {
                if (nonVariableStr) {
                    fragments.push(nonVariableStr);
                    nonVariableStr = '';
                }
                const dataValue = node.getAttribute('data') || '';
                fragments.push(dataValue);
                return; // 不递归子节点，忽略内部内容
            }

            const tagName = node.tagName.toLowerCase();

            // 处理换行标签 <br>
            if (tagName === 'br') {
                nonVariableStr += '\n';
                return;
            }

            // 块级元素换行
            if (blockElements.has(tagName)) {
                nonVariableStr += '\n';
                if (isOnlyBr(node)) return;
            }

            // 非目标元素，继续递归处理子节点
            node.childNodes.forEach(child => walk(child));
        }
    }

    walk(doc.body);
    if (nonVariableStr) {
        fragments.push(nonVariableStr);
        nonVariableStr = '';
    }
    return fragments.join(CNF.APP_CONFIG_SPLIT);
}

/**
 * 转显示-格式化变量内容
 * @param {*} content 
 * @param {*} graph 
 * @returns 
 */
export const formattedContent = (content, graph) => {
    // 按照分割字符串格式化内容
    let newContent = '';
    if (content) {
        const contents = content.split(CNF.APP_CONFIG_SPLIT);
        for (let i = 0; i < contents.length; i++) {
            let item = contents[i].replaceAll('\n', '<br>');
            if (item.split('/').length > 1 && /^([0-9]{1,})$/.test(item.split('/')[0])) {
                const parts = item.split('/');
                const nodeId = parts[0];
                // 节点名称
                const nodeName = graph.getNodes().find(node => node.getZIndex().toString() === nodeId).data.title || nodeId;
                newContent += `<span class="variable-tag" contenteditable='false' data=${item}>${nodeName}/<span class="variable-name">${parts.at(-1)}</span></span>`;
            } else newContent += item;
        }
    }
    return newContent;
};